import React from 'react';
import OrgSurveyCompareRow from './OrgSurveyCompareRow/index';

const OrgSurveyCompareList = ({ orgSurveysCompare, onOrgSurveyCompareSelect }) => {
    return (
        <div className="app-main-content">
            {orgSurveysCompare ? orgSurveysCompare.map((data, index) =>
                <OrgSurveyCompareRow key={index} orgSurveyCompare={data} onOrgSurveyCompareSelect={onOrgSurveyCompareSelect}
                />
            ) : null}
        </div>
    );
};

export default OrgSurveyCompareList;


// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/OrgSurveyCompareList/index.js